export const agendaData = {
  day1: {
    conferencias: [
      {
        title: "Acreditaciones & Acceso",
        speaker: "",
        hour: "10:00 - 11:00"
      },
      {
        title: "Opening Ceremony - Day 1",
        speaker: "Gobierno del Estado de Nuevo León, Gobierno del Municipio de Monterrey, Ethereum México",
        hour: "11:00 - 11:30"
      },
      {
        title: "PANEL: Por qué Cripto, Blockchain y la Descentralización Importan",
        speaker: "David (Arbitrum Foundation), Yedid (Her DAO Mexico), Aime Figeroa <br /> Mod: Liz Durán (Eth México)",
        hour: "11:40 - 12:20"
      },
      {
        title: "PANEL: Confianza en la Blockchain: Salud, Dinero y Datos en la Era Descentralizada",
        speaker: "María Fernanda Pérez (MicrobiomeDAO), Alberto Franco (BWC), Carlos Serna (Gobierno de Nuevo León) <br />  Mod: Julio Flores (Patrimonio XYZ)",
        hour: "12:30 - 13:10"
      },
      {
        title: "PANEL: Instituciones Onchain: El Próximo Capítulo de las Finanzas en México",
        speaker: "Javier Murga (Transformación de Activos Digitales), Ale RaMo (Wavy Node), Humberto Besso (Scroll) <br />  Mod: Meximalist" ,
        hour: "13:20 - 14:00"
      },
      {
        title: "Cripto-Revolución: El Futuro de la Economía Descentralizada",
        speaker: "Carlos Ocampo - TEDx Speaker",
        hour: "14:10 - 14:35"
      },
      {
        title: "BREAK / LUNCHTIME",
        speaker: "",
        hour: "14:35 - 15:35"
      },
      {
        title: "PANEL: Designing Trust: Exchanges, Wallets & the Future of Everyday Crypto",
        speaker: "Brian (PistachioFi), Andrés Salcedo (Etherfuse), Zeymer Montes (Moca App), Rafa Canseco (OdiseaLabs). Mod: Yazareth Sánchez",
        hour: "15:35 - 16:15"
      },
      {
        title: "ARBITRUM Keynote: Expanding Arbitrum Across Mexico and Latin America",
        speaker: "Joao Kury (Arbitrum Foundation)",
        hour: "16:25	- 16:50"
      },
      {
        title: "Keynote: Cómo conseguir los primeros 100 usuarios de tu protocolo",
        speaker: "Diego Tenorio (Fundamento)",
        hour: "17:00 - 17:25"
      },
      {
        title: "Regulación: Oportunidades legales para la disrupción Blockchain",
        speaker: "Carlos Valderrama",
        hour: "17:35	- 18:00"
      },
      {
        title: "Performance inmersiva en vivo",
        speaker: "Creatress",
        hour: "18:10	- 18:35"
      }
    ],
    hackathon: [
      {
        title: "Presentación Hackathon",
        hour: "18:00 - 19:00",
        speaker: "Mitch & Erezedor"
      },
      {
        title: "Team formation & project ideation",
        hour: "19:00 - 20:00",
        speaker: "Mitch"
      },
      {
        title: "Hacking Time!",
        hour: "19:00 - 23:59",
        speaker: ""
      },
      

    
    ]
  },
  day2: {
    conferencias: [
      {
        title: "Acreditaciones & Acceso",
        speaker: "",
        hour: "10:00 - 11:00"
      },
      {
        title: "Opening Ceremony - Day 2",
        speaker: "Ethereum México Team, ETH Monterrey Team y Monterrey Tech Week",
        hour: "11:00 - 11:30"
      },
      {
        title: "Debate: Bitcoin vs Ethereum",
        speaker: "Don Pepe (Eth México), Adrián Treviño (Bitcoin Network Monterrey), Rafa Cárdenas (Stacks), JuanRah (SeedGov) <br /> Mod: Ana Belén (Eth México)",
        hour: "11:40 - 12:05"
      },
      {
        title: "ETHERFUSE: Finanzas 3.0",
        speaker: "Andrés Salcedo (Etherfuse)",
        hour: "12:15	- 12:40"
      },
      {
        title: "Fireside - Identidad Descentralizada en Acción: El Caso de Nuevo León con Sovra",
        speaker: "Chuy Cepeda (Sovra), Mariela Saldivar (Gobierno NL), Diego Fernández (Sovra) <br /> Mod: JuanRah (SeedGov)",
        hour: "12:50	- 13:15"
      },
      {
        title: "PANEL: The Inclusion Imperative: Unbanked to Onchain",
        speaker: "Saswat Sahu, Etienne Luquet (Tools for Humanity), Almond Hernández (Base) <br /> Mod: Abraham Rivv (Espacio Cripto)",
        hour: "13:25 - 14:05"
      },
      {
        title: "BREAK / LUNCHTIME",
        speaker: "",
        hour: "14:05 - 15:05"
      },
      {
        title: "Keynote: El futuro corre sobre Scroll: innovación, pagos y la nueva generación de la economía abierta",
        speaker: "Gabriella Mena (Scroll)",
        hour: "15:05 - 15:30"
      },
      {
        title: "Keynote: De Idea a Impacto Onchain: Escala con Base",
        speaker: "Almond - Base",
        hour: "15:40	- 16:05"
      },
      {
        title: "Arquitectura de Confianza: Ethereum y el Futuro de la Seguridad",
        speaker: "Paul Cortés - Hiv3",
        hour: "16:15 - 16:40"
      },
      {
        title: "The Role of Stablecoins and DeFi in Value Creation across the Ethereum Ecosystem",
        speaker: "Rine Dunia (CW3), Alan Kantapin (CW3)",
        hour: "16:50 - 17:15"
      },
      {
        title: "Mercados abiertos, acceso global: el papel de las DEX en la transformación financiera",
        speaker: "Anthony Chávez (Uniswap Labs)",
        hour: "17:25	- 17:50"
      },
      {
        title: "Sorpresa Cultural: El Alma de México",
        speaker: "Ensamble de la Gran Orquesta de Monterrey, el Ballet Folklórico de Monterrey y Catrinas Aztecas de Danzas Prehispánicas Tonatiuh",
        hour: "18:00	- 18:25"
      }
    ],
    hackathon: [
      {
        title: "El camino del VibeCoder: Universitarios en Web3",
        hour: "09:00 - 10:00",
        speaker: "Gerardo Vela (Cripto UNAM)"
      },
      {
        title: "Resolviendo PPU's (P**#*$s Problemas Urgentes)",
        hour: "10:00 - 11:00",
        speaker: "Karina Córdova - Irrazonables"
      },
      {
        title: "Workshop: Scroll",
        hour: "11:00 - 12:00",
        speaker: "Irwing Durán (Scroll)"
      },
      {
        title: "Desarrolla tu propio protocolo DeFi con Uniswap V4 Hooks",
        hour: "12:00 - 13:00",
        speaker: "Constantino Mora (Uniswap Foundation Ambassador)"
      },
      {
        title: "Como pitchear tu proyecto en el hackathon",
        hour: "13:00 - 14:00",
        speaker: "Israel Cortes (Omma Cash)"
      },
      {
        title: "Arbitrum - Stylus",
        hour: "14:00 - 15:00",
        speaker: "Erezedor (Eth México)"
      },
      {
        title: "Identidad Web3, ENS y L2: Taller para Hackers",
        hour: "15:30 - 17:00",
        speaker: "Scarf (Frutero Club)"
      },
      {
        title: "Marketing auténtico: captar atención en Web3",
        hour: "17:00 - 18:00",
        speaker: "Irwing Tello"
      }
      

    ]
  },
  day3: {
    conferencias: [],
    hackathon: [
      {
        title: "Submission Deadline",
        hour: "08:00",
        speaker: ""
      },
      {
        title: "Submission Pitches",
        hour: "8:00 - 9:15",
        speaker: ""
      },
      {
        title: "Evaluación de proyectos",
        hour: "9:15 - 12:00",
        speaker: ""
      },
      {
        title: "Deliberar ganadores",
        hour: "12:00 - 13:00",
        speaker: ""
      },
      {
        title: "Closing Ceremony and Winners Announcement",
        hour: "13:00 - 14:30",
        speaker: ""
      },
    ]
  }
};
